module.exports = {"StatusCode":200,"Payload":[{"productInventory":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getDynamicItem.json
// module id = CRpR
// module chunks = 0